import { TenantSettingsESignaturesDto } from './tenant-settings-e-signatures.dto';
import { TenantSettingsGpsTrackersDto } from './tenant-settings-gps-trackers.dto';
import { TenantSettingsPaymentProvidersDto } from './tenant-settings-payment-providers.dto';

export class TenantSettingsIntegrationsDto {
  gpsTrackers?: TenantSettingsGpsTrackersDto | null;
  paymentProviders?: TenantSettingsPaymentProvidersDto | null;
  eSignatures?: TenantSettingsESignaturesDto | null;
}
